import { MaterialModule } from '@sdbn/appclient';
import { CommonModule } from '@angular/common';
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ForwardToStationStructureSelectionDialogComponent } from './component/forward-to-station.component';
import { DictionaryModule } from '@sdbn/appclient';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { TmcYardCommonModule } from 'src/tmc-yard/common/common.module';
import { StructureSelectionModule } from 'src/tmc-yard/common/structure-selection/structure-selection.module';

@NgModule({
  declarations: [
    ForwardToStationStructureSelectionDialogComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CommonTranslationModule,
    DictionaryModule,
    ApplicationClientCommonModule,
    TmcYardCommonModule,
    StructureSelectionModule
  ],
  exports: []
})
export class ForwardToStationModule { }
